/**
 * The custom property the app shell sets to the height of the row it keeps at the bottom of the
 * window: the assistant's bar below `lg` (#6128), or `0px` when nothing is there.
 *
 * A pane fixed to the window's edges (a drawer's paper) is laid out against the window, not the
 * shell's rows, so on its own it runs down behind the bar. Ending at this height leaves the bar
 * reachable while the pane is open.
 */
export const SHELL_BOTTOM_BAR_HEIGHT_PROPERTY = "--shell-bottom-bar-height";

/** The bar's height where a style needs it, and nothing where the shell sets none. */
export function shellBottomBarHeight(): string {
  return `var(${SHELL_BOTTOM_BAR_HEIGHT_PROPERTY}, 0px)`;
}
